import { useTranslation } from 'react-i18next';

import { useAuthActions, useAuthModal } from 'authOld/hooks';
import { mapCreateLocationForm } from 'authOld/mappers';
import { AddressForm } from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { IAddress } from 'coreOld/types';

interface IProps {
  onNext: (step: HeaderModalOptions) => void;
}

const CreateLocationForm = ({ onNext }: IProps) => {
  const { t } = useTranslation();
  const { createLocation } = useAuthActions();
  const { openedAuthModal, closeAuthModal } = useAuthModal();

  const onSubmit = () => async (data: IAddress) => {
    const { success } = await createLocation(mapCreateLocationForm(data));

    if (!success) {
      return;
    }

    onNext(HeaderModalOptions.CREATE_LOCATION);
  };

  return (
    <AddressForm
      isOpen={openedAuthModal === HeaderModalOptions.CREATE_LOCATION}
      onClose={closeAuthModal}
      title={t('labelCreateLocation')}
      submitBtnLabel={t('buttonLabelCreateLocation')}
      onSubmit={onSubmit}
    />
  );
};

export default CreateLocationForm;
